var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{style:({ width: _vm.size, height: _vm.size }),attrs:{"src":"/static/images/spinner.svg"}})])}
var staticRenderFns = []

export { render, staticRenderFns }